import { useCallback, useEffect, useState } from 'react';

export function useOnMessage<T>(message: string, callback: (value: T) => void) {
  const handler = useCallback(
    (e: unknown) => {
      if ((e as MessageEvent).data.type === message) {
        callback((e as MessageEvent).data.value);
      }
    },
    [callback, message],
  );

  useEffect(() => {
    window.addEventListener('message', handler);
    return () => window.removeEventListener('message', handler);
  }, [message, handler]);
}

export function useMessageParameter<T>(message: string, initialValue?: T) {
  const [value, setValue] = useState<T | undefined>(initialValue);
  useOnMessage<T>(message, (newValue) => setValue(newValue));
  return value;
}

export function postCdnLocation(
  iframe: HTMLIFrameElement | null,
  urlOrPath: string,
) {
  iframe?.contentWindow?.postMessage({
    type: 'cdnSetLocation',
    value: urlOrPath,
  });
}
